<template>
  <div class="dashboard_main">
    <ul class="game_modes">
      <li>
        <router-link
          to="/inventory"
          class="position-relative menu-link inventory_link inventory-bg"
        >
          <img src="images/Depo.png" class="img-fluid depo-img" />
          <img src="/images/Depo_h.png" class="img-fluid hover-img" />
          <span class="bg-img coming_text">
            <span class="coming_text"> Inventory </span>
          </span>
        </router-link>
      </li>
      <li class="postion-relative">
        <router-link to="/map" class="ahir position-relative menu-link map-bg">
          <img src="images/Ahır.png" class="img-fluid map-img ahır-img" />
          <img src="images/Ahır_h.png" class="img-fluid hover-img ahirhover-img" />
          <span class="coming_text bg-img">
            <span class="coming_text"> Map </span>
          </span>
        </router-link>
        <router-link
          to="/market"
          class="market position-relative menu-link market-bg"
        >
          <img src="images/Market.png" class="img-fluid market-img" />
          <img src="images/Market_h.png" class="img-fluid hover-img markethover-img" />
          <span class="coming_text bg-img">
            <span class="coming_text"> Market </span>
          </span>
        </router-link>
        <a
          href="#"
          class="bank position-relative menu-link bank-bg"
          @click="isShow = true"
        >
          <img src="images/Bank.png" class="img-fluid bank-img" />
          <img src="images/Bank_h.png" class="img-fluid bank-img hover-img bankhover-img" />
          <span class="coming_text bg-img">
            <span class="coming_text"> Bank </span>
          </span>
        </a>
        <a href="/crafting" class="ev position-relative menu-link">
          <img src="images/Ev.png" class="img-fluid ev-img" />
          <img src="images/Ev_h.png" class="img-fluid hover-img evhover-img" />

          <span class="coming_text bg-img">
            <span class="coming_text"> Crafting / Upgrade </span>
          </span>
        </a>
        <a href="#" class="araba menu-link">
          <img src="images/Araba.png" class="img-fluid araba-img" />
          <img src="images/Araba_h.png" class="img-fluid hover-img h-100 arabahover-img" />
          <span class="coming_text bg-img">
            <span class="coming_text"> Coming Soon </span>
          </span>
        </a>
      </li>
    </ul>

    <WalletInfoModal
      v-if="isShow"
      :showModel="isShow"
      v-on:w-modal-hide-click="isShow = false"
    />
  </div>
</template>

<script>
import WalletInfoModal from "../components/Modal/WalletInfoModal.vue";
export default {
  name: "Dashboard",
  components: {
    WalletInfoModal,
  },
  data() {
    return {
      isShow: false,
    };
  },
};
</script>
<style scoped>
.dashboard_main {
  font-family: "WesternBangBang-Regular";
}
img {
  width: 100%;
}
.card-count {
  position: relative;
  bottom: 26px;
}
.dashboard_main {
  height: 100%;
  width: 100%;
}
.game_modes {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.game_modes li {
  display: flex;
  justify-content: space-between;
  align-items: end;
}
.ahir {
  left: 305px;
  position: relative;
}
.market {
  left: 230px;
  position: relative;
}
.bank {
  left: 140px;
  position: relative;
}
.ev {
  position: relative;
  top: 80px;
}
.araba {
  position: absolute;
  right: 0;
  bottom: 0;
}
.hover-img {
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  height: 100%;
}
.ahirhover-img{
  width: 306px;
  height: 144px;
}
.markethover-img{
  width: 228px;
  height: 230px;
}
.bankhover-img{
  width: 229px;
  height: 284px;
}
.evhover-img{
  width: 210px;
  height: 398px;
}
.arabahover-img{
  width: 191px;
  height: 158px;
}
.menu-link:hover .depo-img ,
.menu-link:hover .ahır-img ,
.menu-link:hover .market-img,
.menu-link:hover .bank-img,
.menu-link:hover .ev-img,
.menu-link:hover .araba-img {
  display: none;
}
.menu-link:hover .hover-img {
  display: inline-block;
  position: relative;
}

.game_modes a:hover span {
  color: orange;
}

.menu-link .bg-img {
  background: url("/images/Brush_1.png") no-repeat;
  background-size: 100% 100%;
  height: 35px;
  top: -4%;
  width: 55%;
  margin: auto;
  text-align: center;
}
.coming_text {
  color: #fff;
  position: absolute;
  top: 20%;
  width: 100%;
  text-transform: uppercase;
  font-size: 22px;
  left: 0;
  text-align: center;
  z-index: 8;
}

.inventory-bg .bg-img {
  width: 42%;
  left: 34%;
  top: 15%;
}
.bank-bg .bg-img {
  width: 40%;
  left: 20px;
}

.ev span {
  width: 80%;
  left: 20px;
}
.ev .bg-img {
  width: 92%;
  top: 0;
  left: 14px;
  bottom: 100%;
}
.araba span {
  top: 8px;
  left: 0;
}
.araba .bg-img {
  width: 70%;
  top: 3%;
}

.map-bg .bg-img {
  width: 25%;
  left: 20px;
  top: -5%;
}

@media (max-width: 768px) {
  .dashboard_main {
    background: none;
  }
  .ahir {
    left: 65px;
    top: 60px;
  }
  .ahir span {
    top: 10px;
    left: 0px;
  }
  .market {
    left: 60px;
    top: 60px;
  }
  .bank {
    left: 34px;
    top: 60px;
  }
  .ev .bg-img {
    left: 15px;
  }
  .coming_text {
    font-size: 12px;
  }
  .menu-link .bg-img {
    top: -35%;
    width: 75%;
  }
  .bank-bg .bg-img {
    left: 0;
  }
  .ev span {
    left: 0px;
  }
  .inventory_link {
    top: 70px;
  }
  /* .araba {
    width: 30%;
    bottom: 12%;
  } */
  .araba .bg-img {
    top: -15%;
    left: 10%;
  }
  .inventory-bg .bg-img {
    top: 10%;
    left: 10%;
  }
  .araba span {
    top: 10px;
    left: 0px;
  }
  .map-bg .bg-img {
    width: 50%;
  }
}
/* @media (max-width: 576px) {
  .araba {
    width: 30%;
    bottom: 22%;
  }
}
@media (max-width: 375px) {
  .araba {
    bottom: 17%;
  }
} */
</style>